import { SMap } from '@avantia/client-and-server-utilities';
import { createAddress } from '../../../createAddress';
import {
  HpImageButtonListControlProps,
  ImageButtonListControl
} from '../../../engineClient/components/formControls/standard';
import { HpClientQuestionData, HpClientQuestionLookupItemMap } from '../../../engineClient/types';
import { coverTypeMap, getCoverTypeCode } from '../../../tools/utilities';
import { Policy, PolicyMap } from '../../../types/policyTypes';
import { HpClaimsQuestionSetPageProps } from '../../questionSetForm/questionSetPageTypes';

const buildingsAndContentsImage = 'coverTypes/B_C_Icon{{selected?-selected}}.svg';
const buildingsImage = 'coverTypes/B_Icon{{selected?-selected}}.svg';
const contentsImage = 'coverTypes/C_Icon{{selected?-selected}}.svg';

// A policy map can be passed in (i.e. filtered policies).
export interface SelectPolicyCustomControlProps extends HpImageButtonListControlProps {
  policies?: PolicyMap | undefined;
}

export function SelectPolicyCustomControl(props: SelectPolicyCustomControlProps): JSX.Element | null {
  const { question, questionText } = props;
  let { policies } = props;
  const data = question.data as HpClientQuestionData;
  const lookup: HpClientQuestionLookupItemMap = {};
  let updatedData: HpClientQuestionData | null = null;
  if (!policies) {
    const { pageProps } = props;
    ({ policies } = pageProps as HpClaimsQuestionSetPageProps);
  }

  if (policies) {
    for (const policyReference in policies) {
      const policyInstance = policies[policyReference];
      const coverTypeText = policyInstance && policyInstance.coverType;
      const coverType = getCoverTypeCode(coverTypeText);
      let image: string | null = '';
      switch (coverType) {
        case coverTypeMap.Buildings:
          image = buildingsImage;
          break;
        case coverTypeMap.Contents:
          image = contentsImage;
          break;
        case coverTypeMap.BuildingsAndContents:
          image = buildingsAndContentsImage;
          break;
        default:
          break;
      }

      lookup[policyReference] = { image, text: `${coverTypeText}` };
      updatedData = { ...data, lookup };
    }

    return (
      <ImageButtonListControl
        {...props}
        createCustomOptionWidget={(policyReference) =>
          createPolicyOptionText(policyReference, policies as SMap<Policy>)
        }
        questionText={policies && Object.keys(policies).length > 1 ? questionText : ''}
        data={updatedData || (data as HpClientQuestionData)}
      />
    );
  }

  return null;
}

export function createPolicyOptionText(
  policyReference: string,
  policyData: SMap<Policy>,
  createHeader?: (coverType: string, poicyReference: string) => JSX.Element
): JSX.Element {
  const policyInstance = policyData[policyReference];
  const { house, street, locality, county, postcode } = policyInstance;
  const address: string = createAddress({ house, street, locality, county, postcode });
  const coverType = policyInstance && policyInstance.coverType;

  return (
    <div className="select-policy-widget" key={policyReference}>
      {createHeader ? createHeader(coverType, policyReference) : <strong>{coverType} Insurance</strong>}
      <div>
        <div>
          <strong>Address: </strong>
          {address}
        </div>
        <div>
          <strong>Policy Reference: </strong>
          {policyReference}
        </div>
      </div>
    </div>
  );
}
